// extracted by mini-css-extract-plugin
export default {"subtitle":"yHZd7sruA2","subtitle_accept":"Fhqs1WqUQD","subtitle_unknown":"kAhls0085l","subtitle_decline":"md_1R3dsz5","subtitle_tenative":"_N03YBehBw"};